import MainButton from "../MainButton";

function CtaBanner() {
  return (
    <>
      <section className="cta-section w-full h-auto">
        <div className="container page-padding py-[7rem] text-white">
          <h2 className="text-white text-[3.6rem] font-bold">Need a Fitness Trainer?</h2>
          <h3 className="text-white text-[2.8rem] font-bold mb-20">
            <span className="text-[#ff0336]">Call:</span> +91 94067 61177
          </h3>
          <MainButton
            color={`text-white`}
            bg={`bg-[#ff0336]`}
            text="purchase now"
            arrowColor={`text-white`}
            cN="pricing-cta cta-banner-btn"
            goTo="/contact"
          />
        </div>
      </section>
    </>
  );
}

export default CtaBanner;
